import {
  QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44,
  QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54,
  QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64,
  QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER,
  QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35,
} from './constants';
import { TargetScoreRangeAgeGroup } from '../../../TargetScore';

export function getQtBreakpointsFromAgeGroup(ageGroup: TargetScoreRangeAgeGroup) {
  switch (ageGroup) {
    case 'Under35':
      return QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_UNDER35;
    case '35To44':
      return QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_35TO44;
    case '45To54':
      return QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_45TO54;
    case '55To64':
      return QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_55TO64;
    case '65AndOver':
      return QUALIFIED_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS_65OVER;
    default:
      return [];
  }
}
